import React from "react";
import { aboutImages } from "../../utils/constants";
import headingImg1 from "../../assets/headingImg1.svg";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";

const Who = () => {
  return (
    <div
      id="first"
      className="flex text-justify lg:flex-row flex-col-reverse align-center bg-[#e0faff] px-[3%] 2xl:px-[8%] py-[10px] sm:py-[30px] lg:py-[40px] gap-[2rem] lg:gap-[5rem]"
    >
      <div className="flex w-[100%] md:max-w-[730px] mx-auto lg:w-[45%]">
        <img
          src={
            window.innerWidth > 450
              ? window.innerWidth > 1000
                ? aboutImages.preSchoolImg
                : aboutImages.tabSchoolImg
              : aboutImages.mobileSchoolImg
          }
          alt="who"
          className="rounded-lg mx-auto h-[250px] sm:h-[400px] lg:max-w-[601px] lg:min-w-[600px] sm:w-full w-[380px] lg:h-[380px]"
        />
      </div>
      <div className="w-[100%] lg:w-[50%]">
        <CustomHeading
          text={"We are "}
          customImg={window.innerWidth > 450 && headingImg1}
          heartHeight="60px"
          heartWidth="60px"
          spanText={"More "}
          spanTextColor="#d31c4f"
          thirdText={"Than"}
          smTextSize="32px"
          textSize="50px"
        />
        <CustomHeading
          text={"just a "}
          spanText={"Preschool"}
          smTextSize="32px"
          textSize="50px"
        />
        <CustomContent
          fontWeight={500}
          textAlign="justify"
          textColor="#636363"
          marginTop="20px"
          text={
            "At Mother's Pride, we believe the early years lay the foundation for a child's future. As a leading preschool, we celebrate childhood with love, laughter, and learning, fostering growth through experiential learning, positive parenting, and a nurturing environment. From first steps to lifelong bonds, we make early years magical, meaningful, and memorable!"
          }
        />
      </div>
    </div>
  );
};

export default Who;
